module.exports = __webpack_public_path__ + "static/media/notifications.bf08e43c.svg";